import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MhWelcomePageComponent } from "./mh-welcome-page.component";
import { TranslateModule } from "@ngx-translate/core";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzResultModule } from "ng-zorro-antd/result";
import { NzMessageModule } from "ng-zorro-antd/message";
import { NzSelectModule } from "ng-zorro-antd/select";
import { PasswordValidationTipsModule } from "../../../../../common-ui/src/lib/password-validation-tips/password-validation-tips.module";

@NgModule({
  declarations: [MhWelcomePageComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    NzButtonModule,
    NzFormModule,
    NzInputModule,
    NzIconModule,
    NzCheckboxModule,
    NzRadioModule,
    NzSpinModule,
    NzResultModule,
    NzMessageModule,
    NzSelectModule,
    PasswordValidationTipsModule,
  ],
  exports: [MhWelcomePageComponent],
})
export class MhWelcomePageModule {}
